import {FC} from "react";
import {Button} from "components/shared";
import {BUTTON_VARIANTS} from "components/shared/Button/Button";
import StepInfo from "pages/StepPages/components";
import StepFiveEndImg from "images/step-five-end.svg";
import styles from "./Finish.module.sass";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch} from "toolkit/hooks";
import {setSearch} from "toolkit/steps/stepFive/stepFive.slice";

const Finish: FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const { actId, resId, objectName, category }: any = useLocation().state;

	const { organizationId } = useParams();

	const { objId } = useParams();

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<StepInfo stepTitle="5. Выбор категории значимости" info="Подбор категории" />
				<div className={styles.header_btn}>
					<Link to={`/categorization/newModel/${organizationId}/${objId}`} state={{ objectName,isTemplate:true }} replace={true}>
						<Button variant={BUTTON_VARIANTS.OUTLINED}>
							Создать шаблон
						</Button>
					</Link>
					<Button
						onClick={() => {
							dispatch(setSearch(objectName || ""));
							navigate(`/categorization/documents/${organizationId}`, {
								state: { objectName },
							});
						}}>
						Просмотреть документы
					</Button>
				</div>
			</div>
			<div className={styles.finish}>
				<img src={StepFiveEndImg} alt="finishImg" />
				<div data-comment-false={true} className={styles.text}>
					Процесс подбора категории завершен, объекту
					<span className={styles.objName}>{" " + objectName + " "}</span>{" "}
					{category <= 3 ? `присвоена ${category} категория значимости` : "категория не присвоена"}
				</div>
			</div>
			<div className={styles.footer}>
				<Button variant={BUTTON_VARIANTS.TEXT}>
					<Link
						state={{ docsId: { actId, resId } }}
						to={`/categorization/documents/${organizationId}/${objId}/${actId}`}>
						Просмотр проекта акта категорирования
					</Link>
				</Button>

				<Button variant={BUTTON_VARIANTS.TEXT}>
					<Link to={`/categorization/newModel/${organizationId}/${objId}`} state={{ objectName }} replace={true}>
						Повторно пройти процесс подбора категории
					</Link>
				</Button>

				<Button variant={BUTTON_VARIANTS.TEXT}>
					<Link
						state={{ docsId: { actId, resId } }}
						to={`/categorization/documents/${organizationId}/${objId}/${resId}`}>
						Просмотр проекта сведений об объекте
					</Link>
				</Button>
			</div>
		</div>
	);
};

export default Finish;
